import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/logo_transbg.png';
import { FaFacebookF, FaInstagram, FaYoutube, FaTwitter, FaLinkedin } from 'react-icons/fa';
import { integrationPlatforms } from '../utils/seoMetadata.js';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top-row">
          <div className="footer-left">
            <div className="footer-logo">
              <img src={logo} alt="Clientalio Logo" className="logo-image" />
            </div>
            <p className="footer-description">The easiest way to collect authentic video testimonials from your customers.</p>
            <div className="footer-social" aria-label="Clientalio social media">
              <a href="https://www.facebook.com/clientalio" target="_blank" rel="noopener noreferrer" aria-label="Clientalio on Facebook"><FaFacebookF /></a>
              <a href="https://www.instagram.com/clientalio/" target="_blank" rel="noopener noreferrer" aria-label="Clientalio on Instagram"><FaInstagram /></a>
              <a href="https://www.youtube.com/@clientalio" target="_blank" rel="noopener noreferrer" aria-label="Clientalio on YouTube"><FaYoutube /></a>
              <a href="https://x.com/Clientalio" target="_blank" rel="noopener noreferrer" aria-label="Clientalio on X"><FaTwitter /></a>
              <a href="https://www.linkedin.com/company/clientalio/?viewAsMember=true" target="_blank" rel="noopener noreferrer" aria-label="Clientalio on LinkedIn"><FaLinkedin /></a>
            </div>
          </div>

          <nav className="footer-directory" aria-label="Footer directory">
            <div className="footer-directory-column">
              <Link className="footer-directory-heading" to="/features">Features</Link>
              <ul>
                <li><Link to="/features/review-widgets">Review Widgets</Link></li>
                <li><Link to="/features/testimonial-website-widgets">Website Widgets</Link></li>
                <li><Link to="/features/review-management-software">Review Management</Link></li>
                <li><Link to="/features/customer-feedback-software">Customer Feedback</Link></li>
                <li><Link to="/features/wall-of-love-testimonials">Wall of Love</Link></li>
                <li><Link to="/features/widgets">Social Proof Widgets</Link></li>
                <li><Link to="/features/testimonial-generator">Testimonial Generator</Link></li>
                <li><Link to="/features/ai-testimonial-generator">AI Testimonials</Link></li>
              </ul>
            </div>

            <div className="footer-directory-column">
              <Link className="footer-directory-heading" to="/industry-testimonials">Industry</Link>
              <ul>
                <li><Link to="/industry-testimonials/coaches">Coaches</Link></li>
                <li><Link to="/industry-testimonials/real-estate">Real Estate</Link></li>
                <li><Link to="/industry-testimonials/healthcare">Doctors &amp; Healthcare</Link></li>
                <li><Link to="/industry-testimonials/realtors">Realtors</Link></li>
                <li><Link to="/industry-testimonials/saas">SaaS &amp; Software</Link></li>
                <li><Link to="/industry-testimonials/agencies">Agencies</Link></li>
                <li><Link to="/industry-testimonials/consultants">Consultants</Link></li>
                <li><Link to="/industry-testimonials/ecommerce">Ecommerce</Link></li>
                <li><Link to="/industry-testimonials/creators">Newsletters &amp; Creators</Link></li>
                <li><Link to="/industry-testimonials/events">Events &amp; Conferences</Link></li>
              </ul>
            </div>

            <div className="footer-directory-column">
              <Link className="footer-directory-heading" to="/solutions">Solutions</Link>
              <ul>
                <li><Link to="/solutions/testimonial-software">Testimonial Software</Link></li>
                <li><Link to="/solutions/video-testimonial-software">Video Testimonials</Link></li>
                <li><Link to="/solutions/testimonial-collection-software">Testimonial Collection</Link></li>
                <li><Link to="/solutions/ugc-testimonial-software">UGC & Video Testimonials</Link></li>
                <li><Link to="/solutions/social-proof-software">Social Proof</Link></li>
              </ul>
            </div>

            <div className="footer-directory-column">
              <Link className="footer-directory-heading" to="/resources">Resources</Link>
              <ul>
                <li><Link to="/customer-testimonials">Customer Testimonials</Link></li>
                <li><Link to="/testimonial-guide">Testimonial Guide</Link></li>
                <li><Link to="/customer-feedback-guide">Customer Feedback Guide</Link></li>
                <li><Link to="/testimonial-marketing">Testimonial Marketing</Link></li>
                <li><Link to="/testimonial-examples">Testimonial Examples</Link></li>
                <li><Link to="/testimonial-templates">Templates</Link></li>
                <li><Link to="/how-to-collect-testimonials">Collection Guide</Link></li>
                <li><Link to="/reviews-and-testimonials">Reviews & Testimonials</Link></li>
                <li><Link to="/social-proof-guide">Social Proof Guide</Link></li>
                <li><Link to="/video-testimonial-guide">Video Guide</Link></li>
              </ul>
            </div>

            <div className="footer-directory-column">
              <span className="footer-directory-heading">Support / Help</span>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about-us">About us</Link></li>
                <li><Link to="/alternatives">Alternatives</Link></li>
                <li><Link to="/testimonials">Testimonials</Link></li>
                <li><Link to="/integration">Integration</Link></li>
                <li><Link to="/pricing">Pricing</Link></li>
                <li><Link to="/blog">Blog</Link></li>
                <li><Link to="/faq">How it works</Link></li>
                <li><Link to="/locations">Locations</Link></li>
                <li><Link to="/contact">Contact us</Link></li>
              </ul>
            </div>

            <div className="footer-directory-column footer-integrations-column">
              <Link className="footer-directory-heading" to="/integrations">Integrations</Link>
              <ul className="footer-integrations-list">
                {integrationPlatforms.map((integration) => (
                  <li key={integration.slug}>
                    <Link to={`/integrations/${integration.slug}`}>{integration.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </nav>
        </div>
<br />
        <div className="footer-mid-row footer-legal-centered">
          <ul className="footer-legal-list">
            <li><Link to="/terms-of-use">Terms of use</Link></li>
            <li><Link to="/terms-and-condition">Terms &amp; conditions</Link></li>
            <li><Link to="/privacy-policy">Privacy policy</Link></li>
            <li><Link to="/cookie-policy">Cookie policy</Link></li>
            <li><Link to="/third-party-links">Third-party links</Link></li>
            <li><Link to="/gdpr">GDPR</Link></li>
          </ul>
        </div>

        <div className="footer-bottom">
          <p>© 2025 <span>Clientalio</span>. All rights reserved.</p>
          <p>Developed with ❤️ in India by <a href='https://bwaystechnosolution.co.in/'>BWays Techno Solution</a></p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
